import React from 'react'
import { number, object, func, bool, string } from 'prop-types'
import { EMPTY_OBJECT } from '../../../utils/constants'
import classnames from 'classnames'

const ListItem = ({
  onClick,
  customClass,
  children,
  isInnerHtml,
  item = EMPTY_OBJECT,
  selected = false,
  index,
  listItemProps,
  ...rest
}) => {
  const itemClasses = classnames('ad-list__item', { [customClass]: !!customClass, 'ad-list__item--selected': selected })
  const handleClick = e => {
    onClick(e, item, index)
  }
  return <li className={itemClasses} key={item.name + index} {...listItemProps} {...rest}>
    {isInnerHtml
      ? <a onClick={handleClick} dangerouslySetInnerHTML={{ __html: item.filteredName || item.name }} />
      : <a onClick={handleClick}>{item.name}</a>}
    {children}
  </li>
}

ListItem.propTypes = {
  item: object,
  index: number,
  selected: bool,
  isInnerHtml: bool,
  onClick: func,
  listItemProps: object,
  customClass: string,
  children: object
}

export default React.memo(ListItem)